import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As an organization owner, you can add other npm users to your organization to give them read or read and write access to public and private packages within your organization's scope, as well as public unscoped packages governed by your organization.`}</p>
    <p>{`When you add a member to your organization, they are sent an email inviting them to the organization.`}</p>
    <p>{`Once the new member `}<a parentName="p" {...{
        "href": "accepting-or-rejecting-an-org-invitation"
      }}>{`accepts the invitation`}</a>{`, they are:`}</p>
    <ul>
      <li parentName="ul">{`assigned the role of "`}<a parentName="li" {...{
          "href": "org-roles-and-permissions"
        }}>{`member`}</a>{`"`}</li>
      <li parentName="ul">{`added to the `}<a parentName="li" {...{
          "href": "about-developers-team"
        }}>{`"developers" team`}</a></li>
    </ul>
    <p>{`If you have a `}<a parentName="p" {...{
        "href": "upgrading-to-a-paid-org-plan"
      }}>{`paid organization`}</a>{`, as part of an npm Teams plan, you will be billed $7 per month for each new member.`}</p>
    <h2>{`Inviting members to your organization`}</h2>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-members-tab'].text}</>
        <>{shared['organization-members-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click the `}<strong parentName="p">{`Invite Members`}</strong>{` button.`}</p>
        <Screenshot src="/organizations/managing-organization-members/invite-members-button.png" alt="Screenshot of the invite members button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the "Username or email" field, type the username or email address of the person you wish to invite. Optionally you can select a specific team to invite the member to.`}</p>
        <Screenshot src="/organizations/managing-organization-members/username-or-email-field.png" alt="Screenshot of the username or email field" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Invite`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-organization-members/invite-button.png" alt="Screenshot of the invite button" mdxType="Screenshot" />
      </li>
    </ol>
    <h2>{`Revoking an organization invitation`}</h2>
    <p>{`As an organization owner, if you've made a mistake in inviting someone to your organization, you can revoke the organization invitation.`}</p>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-members-tab'].text}</>
        <>{shared['organization-members-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click the `}<strong parentName="p">{`Invite Members`}</strong>{` button.`}</p>
        <Screenshot src="/organizations/managing-organization-members/invite-members-button.png" alt="Screenshot of the invite members button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under the "Invitations" field, click the `}<strong parentName="p">{`X`}</strong>{` next to the name of the user invitation you would like to revoke.`}</p>
        <Screenshot src="/organizations/managing-organization-members/revoke-invitation.png" alt="Screenshot of the revoke invitation button" mdxType="Screenshot" />
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      